var _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgIconTip = function SvgIconTip(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 59"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.6864 1 1 3.6864 1 7C1 10.3136 3.6864 13 7 13C10.3136 13 13 10.3136 13 7C13 3.6864 10.3136 1 7 1Z",
    stroke: "#62657A",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    id: "\xE5\xBD\xA2\xE7\x8A\xB6\xE7\xBB\x93\xE5\x90\x88",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.61028 9.49415C7.61028 9.84424 7.34165 10.1281 7.01028 10.1281C6.67891 10.1281 6.41028 9.84424 6.41028 9.49415V6.37339C6.41028 6.02329 6.67891 5.73948 7.01028 5.73948C7.34165 5.73948 7.61028 6.02329 7.61028 6.37339V9.49415ZM7.61684 4.55454C7.61684 4.88591 7.34821 5.15454 7.01684 5.15454C6.68547 5.15454 6.41684 4.88591 6.41684 4.55454C6.41684 4.22317 6.68547 3.95454 7.01684 3.95454C7.34821 3.95454 7.61684 4.22317 7.61684 4.55454Z",
    fill: "#62657A"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgIconTip);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-tip.fc4c4ef1.svg";